export const PLAN_TYPE_FIXED_VALUE = 2;

export function isFixedValuePlanType(planType?: number | null): boolean {
  return planType === PLAN_TYPE_FIXED_VALUE;
}

export function resolveClubDisplayAmount(flatRate: number, total: number, planType?: number | null): number {
  return isFixedValuePlanType(planType) ? total : flatRate;
}

export function shouldShowFinancialCharges(planType?: number | null, isOnlyProduct9 = false): boolean {
  return !isOnlyProduct9 && !isFixedValuePlanType(planType);
}
